export const ASSETS_PATH = 'https://s3.amazonaws.com/shooting-star-productions';
